export enum RoleEnum {
  // super admin
  SUPER = 'super',

  // tester
  TEST = 'test',

  ONLINE = 'online',
  OFFLINE = 'offline',
}
